module.exports = __webpack_public_path__ + "media/images/placeholder-icon-nav-hover-212a006178747ea9655fcd3d4262b347.svg";